export const isStandaloneApp = (): boolean => {
  const subdomain = process.env.Ai_SAAS_SUBDOMAIN;
  const currentHost = window.location.origin;
  return currentHost === subdomain;
};

/** 获取登录后的默认首页路径 */
export const getHomePath = (): string => {
  return isStandaloneApp() ? '/app/mine' : '/org/user';
};

/** 是否为租户子域名形式（xxx.子域名.域名.com，≥4 段且非 IP） */
export const isTenantSubdomain = (): boolean => {
  const hostname = window.location.hostname;
  if (!hostname) return false;
  if (/^\d+\.\d+\.\d+\.\d+$/.test(hostname)) return false;
  return hostname.split('.').length >= 4;
};

/** 根据当前域名解析租户编码：
 *  - xxx.子域名.域名.com 形式取第一段 xxx
 *  - 子域名.域名.com 或 IP 地址统一返回 demo
 */
export const getTenantCode = (): string => {
  if (!isTenantSubdomain()) return 'demo';
  return window.location.hostname.split('.')[0] || 'demo';
};
